import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M10.72 6.712l10.28 -3.712l-3.724 10.313m-1.056 2.925l-1.72 4.762a.55 .55 0 0 1 -1 0l-3.5 -7l-7 -3.5a.55 .55 0 0 1 0 -1l4.775 -1.724","key":"svg-0"}],["path",{"d":"M3 3l18 18","key":"svg-1"}]]

const IconLocationOff = createReactComponent('outline', 'location-off', 'LocationOff', __iconNode);

export default IconLocationOff;